export function createContextLostDialog() {
	const dialog = document.createElement("dialog");
	const title = document.createElement("h2");
	const btns = document.createElement("div");
	const closeBtn = document.createElement("button");

	dialog.classList.add("wasm-contextlost-dialog");
	closeBtn.type = "button";
	closeBtn.classList.add("approve");
	closeBtn.textContent = "Zavřít";
	btns.classList.add("btns");
	btns.classList.add("report");
	title.textContent = "Ztráta contextu webgl - zkuste reload okna";
	btns.append(closeBtn);
	dialog.append(title, btns);
	document.body.append(dialog);
	closeBtn.addEventListener("click", () => {
		dialog.close();
		dialog.remove();
	});
	dialog.showModal();
}
